/**
 * Punësimet, historiku dhe rikthimi i kandidatëve — një vend për thirrjet.
 *
 * Çdo listë faqoset te serveri: historiku i rekrutimit është pjesa që rritet pa
 * fund, dhe ajo nuk lexohet kurrë e tëra te shfletuesi.
 */
import { authFetch } from './apiServices';

function qs(params = {}) {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '' || v === 'all') continue;
    sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

async function get(path) {
  try {
    const r = await authFetch(path).then((x) => x.json());
    return r?.success ? r.data : { error: r?.error || 'Kërkesa dështoi.' };
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

async function send(path, method, body) {
  try {
    const r = await authFetch(path, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    }).then((x) => x.json());
    return r?.success ? r.data : { error: r?.error || 'Veprimi dështoi.' };
  } catch (_) {
    return { error: 'Lidhja me serverin dështoi.' };
  }
}

const EMPTY_PAGE = { data: [], pagination: { page: 1, limit: 25, total: 0, totalPages: 1 } };

export default function recruitmentHistoryService() {
  return {
    /** Punësimet — aplikime me fazën `hired`, me ofertën dhe punëtorin kur ekzistojnë. */
    async hires(params = {}) {
      const d = await get(`/api/recruitment/hires${qs(params)}`);
      return d.error ? { ...EMPTY_PAGE, stats: null, error: d.error } : d;
    },

    /** Kërkimi historik mbi të gjitha aplikimet, përfshirë pozitat e mbyllura. */
    async history(params = {}) {
      const d = await get(`/api/recruitment/history${qs(params)}`);
      return d.error ? { ...EMPTY_PAGE, error: d.error } : d;
    },

    /** Identiteti i një personi dhe kronologjia e tij nëpër aplikime. */
    candidate(id) { return get(`/api/recruitment/candidates/${id}`); },

    /** Kandidatë ekzistues që mund të kenë kuptim për një pozitë. */
    matches(postingId, params = {}) { return get(`/api/recruitment/postings/${postingId}/matches${qs(params)}`); },

    invitations(params = {}) { return get(`/api/recruitment/invitations${qs(params)}`); },

    /** Fto — jo ofertë. Serveri e refuzon nëse politika e rikontaktit nuk e lejon. */
    invite(candidateId, jobPostingId, note) {
      return send('/api/recruitment/invitations', 'POST', { candidateId, jobPostingId, note });
    },

    respond(invitationId, status, note) {
      return send(`/api/recruitment/invitations/${invitationId}`, 'PATCH', { status, note });
    },

    /** Krijon një aplikim TË RI; aplikimi i vjetër nuk preket. */
    createApplication(invitationId, position) {
      return send(`/api/recruitment/invitations/${invitationId}/application`, 'POST', { position });
    },
  };
}
